/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "amplifyIdentityBrokerApi",
            "endpoint": "https://mi5ujlfv79.execute-api.ap-northeast-1.amazonaws.com/stg",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_iR1LEPtPH",
    "aws_user_pools_web_client_id": "6t0o09p6panpb87ksdareuhnt",
    "oauth": {
        "domain": "halmek-oidc-op-stg.auth.ap-northeast-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://drlqlurtufp6p.cloudfront.net",
        "redirectSignOut": "https://drlqlurtufp6p.cloudfront.net/logout",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_content_delivery_bucket": "halmek-oidc-op-hosting-stg",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://drlqlurtufp6p.cloudfront.net",
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "amplifyIdentityBrokerClients-stg",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "amplifyIdentityBrokerCodes-stg",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "amplifyIdentityBrokerLoginHistory-stg",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "amplifyIdentityBrokerDeviceHistory-stg",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "amplifyIdentityBrokerIpHistory-stg",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "amplifyIdentityBrokerUsedTokens-stg",
            "region": "ap-northeast-1"
        }
    ]
};


export default awsmobile;
